class ComplainRanking {
  constructor() {

    if(document.querySelector('.complain-ranking') != null && document.querySelector('.complain-ranking') != undefined) {
      this.setEvents();
    }
  }

  setEvents() {
    var compare = document.querySelector('.complain-ranking__compare .compare__companies');

    if(compare != null && compare != undefined) {
      var sections = compare.querySelectorAll('[data-section]');

      function ToggleAccordions(type) {
        sections.forEach(s => {
          if(s.getAttribute('data-section') == type) {
            var body = s.querySelector('.section__body');
            if(body.parentNode.classList.contains('opened')) {
              body.style.maxHeight = 0;
              body.parentNode.classList.remove('opened');
            } else {
              body.style.maxHeight = body.scrollHeight + "px";
              body.parentNode.classList.add('opened');
            }
          }       
        });
      }

      sections.forEach(s => {
        var head = s.querySelector('.section__head');
        head.addEventListener('click', function(e) {
          e.preventDefault();
          ToggleAccordions(head.parentNode.getAttribute('data-section'));
        });
      });
    }
  }

}

$(document).ready(function() {
  const complainRanking = new ComplainRanking();
});
